import { render, staticRenderFns } from "./video-field.vue?vue&type=template&id=2e1139ca&scoped=true"
import script from "./video-field.vue?vue&type=script&lang=js"
export * from "./video-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1139ca",
  null
  
)

export default component.exports